export default __webpack_public_path__ + "static/alloy_paragraph_image-4e66f4712ac2274034c5f703089a73b9.webp";